/**
 * Starts the MSW browser worker when the app is run with `VITE_ENABLE_MSW=true`
 * (the `dev:mock` script). Unmocked operations pass through to the real backend,
 * so this is safe to layer on top of a normal authenticated session.
 *
 * This module is only ever imported dynamically from `main.tsx`, so `msw/browser`
 * is never pulled into a production bundle.
 */
export async function enableMocking(): Promise<void> {
  if (import.meta.env.VITE_ENABLE_MSW !== "true") {
    return;
  }

  const { worker } = await import("./browser");

  await worker.start({
    // Unmocked requests go straight to the real backend without noisy warnings.
    onUnhandledRequest: "bypass",
    quiet: false,
  });

  console.info(
    "🧪 MSW mock layer enabled.\n" +
      "  · Whole-query failure: ?mockErrors=GetPlaybookResults  (or =all, :404, :network)\n" +
      "  · Partial field failure: ?mockFieldErrors=GetCall:getCall.transcription"
  );
}
